import md5 from 'js-md5';
import addinstance from './instance.js'
import geturl from './seturl'
//平台权限
export const privileges= params=> {return addinstance().get(geturl(`/privileges/index`),{params:params});}
export const createprivileges= params => { return addinstance().post(geturl(`/privileges/create`), params) };
export const updateprivileges= params => { return addinstance().post(geturl(`/privileges/update`), params) };
export const deleteprivileges= params => { return addinstance().post(geturl(`/privileges/delete`), params) };
//集团
export const company_privileges= params=> {return addinstance().get(geturl(`/company_privileges/index`),{params:params});}
export const company_createprivileges= params => { return addinstance().post(geturl(`/company_privileges/create`), params) };
export const company_updateprivileges= params => { return addinstance().post(geturl(`/company_privileges/update`), params) };
export const company_deleteprivileges= params => { return addinstance().post(geturl(`/company_privileges/delete`), params) };
//酒店方权限
export const hotel_privileges= params=> {return addinstance().get(geturl(`/hotel_privileges/index`),{params:params});}
export const hotel_createprivileges= params => { return addinstance().post(geturl(`/hotel_privileges/create`), params) };
export const hotel_updateprivileges= params => { return addinstance().post(geturl(`/hotel_privileges/update`), params) };
export const hotel_deleteprivileges= params => { return addinstance().post(geturl(`/hotel_privileges/delete`), params) };
//公寓权限
export const aprtment_privileges= params=> {return addinstance().get(geturl(`/aprtment_privileges/index`),{params:params});}
export const aprtment_createprivileges= params => { return addinstance().post(geturl(`/aprtment_privileges/create`), params) };
export const aprtment_updateprivileges= params => { return addinstance().post(geturl(`/aprtment_privileges/update`), params) };
export const aprtment_deleteprivileges= params => { return addinstance().post(geturl(`/aprtment_privileges/delete`), params) };







// WEBPACK FOOTER //
// ./src/api/privilegesapi.js